<template>
  <div class="app">

    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="#">
        <img class="navbar-brand-full" src="img/logo.png" height="50" alt="MFU">
        <img class="navbar-brand-minimized" src="img/logo.png" height="50" alt="MFU">
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg" :defaultOpen=true />
      <b-navbar-nav class="d-md-down-none">
        <!--<b-nav-item class="px-3" to="/dashboard">Dashboard</b-nav-item>-->
        <!--<b-nav-item class="px-3" to="/users" exact>Users</b-nav-item>-->
        <!--<b-nav-item class="px-3">Settings</b-nav-item>-->
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <!--<b-nav-item class="d-md-down-none">-->
        <!--<i class="icon-bell"></i>-->
        <!--<b-badge pill variant="danger">5</b-badge>-->
        <!--</b-nav-item>-->
        <!--<b-nav-item class="d-md-down-none">-->
        <!--<i class="icon-list"></i>-->
        <!--</b-nav-item>-->
        <!--<b-nav-item class="d-md-down-none">-->
        <!--<i class="icon-location-pin"></i>-->
        <!--</b-nav-item>-->
        <!--<DefaultHeaderDropdownAccnt/>-->
      </b-navbar-nav>
      <!--<AsideToggler class="d-none d-lg-block" />-->
      <!--<AsideToggler class="d-lg-none" mobile />-->
    </AppHeader>
<!--    <AppHeader fixed>-->
<!--      <SidebarToggler class="d-lg-none" display="md" mobile />-->
<!--      <b-link class="navbar-brand" to="#">-->
<!--        <img class="navbar-brand-full" src="img/logo.png" height="50" alt="CoreUI Logo" />-->
<!--        <img class="navbar-brand-minimized" src="img/logo.png" height="50" alt="CoreUI Logo" />-->
<!--      </b-link>-->
<!--      <SidebarToggler class="d-md-down-none" display="lg" :defaultOpen="true" />-->
<!--      <b-navbar-nav class="d-md-down-none">-->
<!--        <b-nav-item class="px-3" to="/Dashboard_63">-->
<!--          แบบสอบถามภาวะการมีงานทำของบัณฑิต (Graduate Employability Survey)-->
<!--        </b-nav-item>-->
        <!--<b-nav-item class="px-3" to="/users" exact>Users</b-nav-item>-->
        <!--<b-nav-item class="px-3">Settings</b-nav-item>-->
<!--      </b-navbar-nav>-->
<!--      <b-navbar-nav class="ml-auto">-->
        <!--<b-nav-item class="d-md-down-none">-->
        <!--<i class="icon-bell"></i>-->
        <!--<b-badge pill variant="danger">5</b-badge>-->
        <!--</b-nav-item>-->
        <!--<b-nav-item class="d-md-down-none">-->
        <!--<i class="icon-list"></i>-->
        <!--</b-nav-item>-->
        <!--<b-nav-item class="d-md-down-none">-->
        <!--<i class="icon-location-pin"></i>-->
        <!--</b-nav-item>-->
        <!--<DefaultHeaderDropdownAccnt/>-->
<!--      </b-navbar-nav>-->
      <!--<AsideToggler class="d-none d-lg-block" />-->
      <!--<AsideToggler class="d-lg-none" mobile />-->
<!--    </AppHeader>-->
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader />
        <SidebarForm />
        <SidebarNav :navItems="nav"></SidebarNav>
        <SidebarFooter />
        <SidebarMinimizer />
      </AppSidebar>
      <main class="main">
        <!-- <Breadcrumb :list="list" /> -->
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
      <AppAside fixed>
        <!--aside-->
        <DefaultAside />
      </AppAside>
    </div>
    <TheFooter>
      <!--footer-->
      <div>
        <span class="ml-1">&copy; 2026 ศูนย์บริการเทคโนโลยีสารสนเทศ มหาวิทยาลัยแม่ฟ้าหลวง</span>
      </div>
      <div class="ml-auto">
        <!-- <span class="mr-1">Powered by</span>
        <a href="https://coreui.io">CoreUI for Vue</a>-->
      </div>
    </TheFooter>
  </div>
</template>

<script>
import nav from "@/_nav";
import api from "../service/api";
import {
  Header as AppHeader,
  SidebarToggler,
  Sidebar as AppSidebar,
  SidebarFooter,
  SidebarForm,
  SidebarHeader,
  SidebarMinimizer,
  SidebarNav,
  Aside as AppAside,
  AsideToggler,
  Footer as TheFooter,
  Breadcrumb
} from "@coreui/vue";
import DefaultAside from "./DefaultAside";
import DefaultHeaderDropdownAccnt from "./DefaultHeaderDropdownAccnt";
import store from "@/store/store";
export default {
  name: "DefaultContainer",
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer
  },
  data() {
    return {
      interval: "",
      time: 0,
      isRunning: false,
      active: true,
      keepAlive: false,
      levelid:0,
      lid:0,
      nav:"",
      // nav:
      //   store.state.user.thaistudent == 1 && store.state.user.levelid == 3
      //     ? nav.items_th3
      //     : store.state.user.thaistudent == 1
      //     ? nav.items_th
      //     : nav.items_eng
    };
  },
  computed: {
    name() {
      return this.$route.name;
    },
    list() {
      return this.$route.matched.filter(
        route => route.name || route.meta.label
      );
    }
  },
  methods: {
    getStudentLevel(){
      this.lid = this.$store.state.user.levelid
      if (this.lid > 10) {
        var num_divide = 0;
        if (this.lid < 99) {
          num_divide = 10;
        } else {
          num_divide = 100;
        }
        this.levelid = Math.floor(this.lid / num_divide)
      } else {
        this.levelid = this.lid;
      }
    },
    incrementTime() {
      // console.log("this.$store",this.$store.state)
      if (this.$store.state.token !=null){
        var decodedString = atob(this.$store.state.token.split(".")[1]);
        var obj = JSON.parse(decodedString);
        var timeout = obj.exp - new Date().getTime() / 1000;
        var sec_num = parseInt(timeout, 10); // don't forget the second param
        var hours = Math.floor(sec_num / 3600);
        var minutes = Math.floor((sec_num - hours * 3600) / 60);
        var seconds = sec_num - hours * 3600 - minutes * 60;

        if (hours < 10) {
          hours = "0" + hours;
        }
        if (minutes < 10) {
          minutes = "0" + minutes;
        }
        if (seconds < 10) {
          seconds = "0" + seconds;
        }

        this.time = hours + ":" + minutes + ":" + seconds;
        this.$store.dispatch("setTimeExp", this.time);
        // console.log("time==",this.time)

        if (this.active == true) {

          if (timeout < 1770 ) { //300
            // console.log("timeout==",timeout)
            this.callApikeepAlive();
          }
        }

        if (this.active == false && timeout < 50) {
          clearInterval(this.interval);
          this.Logout();
        }
      }
      // console.log(timeout);
    },
    toggleTimer() {
      this.interval = setInterval(this.incrementTime, 1000);
      if (this.isRunning) {
        //debugger
        clearInterval(this.interval);
        // console.log("timer stops");
      } else {
        // console.log("timer starts");
      }
      this.isRunning = this.isRunning ? false : true;
      // console.log(this.isRunning);
    },
    callApikeepAlive() {
      if (this.keepAlive == false) {
        this.keepAlive = true;
        api
          .keepalive()
          .then(res => {
            // console.log("keepalive==",res.data)
            // console.log("keepalive==",res.data.token)
            this.$store.dispatch("setToken", res.data.token);
            this.keepAlive = false;

          })
          .catch(err => {
            console.log("callApikeepAlive", err.toString());
            console.log("err", err);
            if (err.toString() == "Error: Request failed with status code 401") {
              this.Logout();
            } else {
              this.keepAlive = false;
            }

          });
      }
    },
    Logout() {
        this.$router.push("/logout");
      // }
      // this.keepAlive = false;
    }
  },
  created() {
    // console.log("store==", this.$store.state.user)
    if ((this.$store.state.user != null) && (this.$store.state.user != undefined) && (this.$store.state.user != '')) {
      this.getStudentLevel();
      this.toggleTimer();
      // console.log("xx==",this.$store.state.user.graduate_status )
      if (this.$store.state.user.postpone_status == 1){
        if (this.$store.state.user.thaistudent == 1) {
          this.nav = nav.items_th70;
        } else {
          this.nav = nav.items_eng70;
        }
      }else{
        if (this.$store.state.user.thaistudent == 1) {
          this.nav = nav.items_th;
        } else {
          this.nav = nav.items_eng;
        }
      }

    } else {
      this.nav = nav.items_logout;
      this.$router.push("/thank");
    }
  },
  onIdle() {
    // console.log("ZZZZ");
    this.active = false;
  },
  onActive() {
    // console.log("hello");
    this.active = true;
  }
};
</script>
